import { render, staticRenderFns } from "./DomiciliosList.vue?vue&type=template&id=5cd4a3fc&"
import script from "./DomiciliosList.vue?vue&type=script&lang=js&"
export * from "./DomiciliosList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports